import { FC } from 'react'
import type { ContainerProps as LayoutProps } from './container'
import Container from './container'
import type { FooterProps } from './footer'
import Footer from './footer'
import type { SectionProps } from './section'
import Section from './section'
import type { SectionItemProps as ItemProps } from './section-item'
import SectionItem from './section-item'

interface LayoutType extends FC<LayoutProps> {
  Footer: typeof Footer
  Section: typeof Section
  Item: typeof SectionItem
}

const Layout = Container as LayoutType
Layout.Footer = Footer
Layout.Section = Section
Layout.Item = SectionItem

export default Layout

export type { LayoutProps, FooterProps, SectionProps, ItemProps }
